import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LambdaFunctionService } from './../../../../../service/lambda-function.service';
import { environment } from '../../../../../../environments/environment';
import { CigSlideshowService } from '../../../../cig/cig-slideshow.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-slideshow-print',
  templateUrl: './slideshow-print.component.html',
  styleUrls: ['./slideshow-print.component.scss']
})
export class SlideshowPrintComponent implements OnInit, OnDestroy {

  @Input() allSlides;
  @Input() profiles: any;
  slides: any;
  main_app_enable = false;
  author: any;
  foursightassets: any;
  env: any;
  lm_name: string;

  private destroy$ = new Subject<void>();

  constructor(
    public lmda_service: LambdaFunctionService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private cigService: CigSlideshowService
  ) {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.env = environment;
    this.lm_name = this.activatedRoute.snapshot.params.id || 'Slide Notes';

    if (this.router.url.includes('fs-reveal')) {
      this.main_app_enable = true;
    }

    this.initSlideData();
  }

  private initSlideData() {
    this.slides = this.cigService.slides;
    this.slides[1]['from'] = 'slideshow Print';
    this.slides.forEach((sl) => {
      delete sl['audio_link'];
    });
    this.slides.push(
      { id: 29, slideBackgroundImage: '', subtext: '', profileText: '', active: true },
      { id: 30, slideBackgroundImage: '', subtext: '', profileText: '', active: true },
      { id: 31, slideBackgroundImage: '', subtext: '', profileText: '', active: true }
    );

    this.author = {
      image: 'author-pic.jpg',
      smallLogo: 'foursight-grey-logo-logotype-trans-w160.png',
      logoicon: 'foursight-grey-logo-icon.png',
      logotext: 'foursight-grey-logo-text.png',
      logoFoursight: 'foursight-grey-logo-logotype-trans-w846.png',
      audio: '',
      lm_audio: true,
    };

    this.foursightassets = {
      clarifyImage: 'clarify-icon-2.png',
      titleClarify: 'Clarify',
      ideateImage: 'ideate-icon-2.png',
      titleIdeate: 'Ideate',
      developImage: 'develop-icon-2.png',
      titleDevelop: 'Develop',
      implementImage: 'impl-icon-2.png',
      titleImplement: 'Implement'
    };
  }
}
